@use "variables" as *;

.list {
  width: 100%;
  padding: 0 !important;
  overflow: hidden;
}
